import { getStore, registerAllSagas } from '@opallabs/wormhole'

/**
 * We need to register our sagas before the redux store is created.
 * addReducer below will initialize the redux store, so call it here.
 * Registering sagas via a direct import would be preferred, but our
 * current patterns inside Action/index.js and registerAction limit our
 * ability to do this because of circular dependencies.
 */
registerAllSagas()

export const BaseStore = getStore()

export default BaseStore
